import { Component, OnInit, Input, Output, EventEmitter, OnChanges, AfterViewInit } from '@angular/core';
import { TaskComponent } from '../../task/task.component';
import { Task } from '../../task';
import { FormBuilder, UntypedFormGroup, FormArray, FormControl, Validators } from '@angular/forms';




@Component({
    selector: 'app-task-project',
    templateUrl: './project.component.html',
    styleUrls: ['./project.component.css'],
    standalone: false
})
export class ProjectComponent extends TaskComponent implements OnInit, AfterViewInit
{

	@Input() form1: UntypedFormGroup;
	@Input() taskId: number;

	@Input() shortTermRentalId: number;

	@Input() reservation: [];

	ngOnInit()
	{
	}
	ngAfterViewInit()
	{
	}
}
